import React from 'react';
import { FAQ } from './';

function AbandonedScreen({ 
  title = "Evaluation Expired", 
  message = "This practical evaluation has expired or was abandoned.", 
  onBack,
  backButtonText = "Go Back",
  // FAQ items are now centralized in the FAQ component
}) {
  return (
    <div className="w-full py-8">
      <div className="text-center mb-8 max-w-2xl mx-auto">
        <div className="mb-6">
          <svg className="mx-auto h-20 w-20 text-yellow-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>
        <h3 className="text-2xl font-bold text-gray-900 mb-4">{title}</h3>
        <p className="text-xl text-gray-600 mb-6 leading-relaxed px-8">
          {message}
        </p>
        
        <div className="w-full max-w-2xl mx-auto mb-8 bg-yellow-50 rounded-lg p-6 border border-yellow-100">
          <div className="flex items-center justify-center">
            <svg className="w-6 h-6 text-yellow-500 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
            <span className="text-lg font-medium text-yellow-600">If you believe this is a mistake, please contact the hiring team for assistance.</span>
          </div>
        </div>
        
        <button
          onClick={onBack}
          className="bg-gray-500 text-white rounded-lg px-8 py-4 text-xl font-medium hover:bg-gray-600 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-opacity-50"
        >
          {backButtonText}
        </button>
      </div>
      
      {/* FAQ Section */}
      <div className="mt-8 pt-6 border-t border-gray-200 max-w-3xl mx-auto">
        <FAQ faqType="abandoned" title="Common Questions" />
      </div>
    </div>
  );
}

export default AbandonedScreen;
